<template>
  <div v-if="bailleur" class="tableWithPerPageSelection">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailBailleur.title', { nom: bailleur.nomCommercial }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
              <dropdownButton
                type="is-addOrEdit"
                class="mgr-2"
                :permission="permsBailleur.maj"
                :actions="actionSecondary"
                @click="() => {
                  $router.push({ name: 'm.baux.bailleur-edit',
                      params: { id: bailleur.id } });
                }">
                  {{ $t('detailBailleur.actions.edit') }}
              </dropdownButton>

            <button class="button is-addOrEdit"
                    @click="genererContrat()">
              {{ $t('detailBailleur.actions.newBail') }}
            </button>
            <b-dropdown class="button is-bottom-left has-text-left">
              <div slot="trigger" class="right">
                <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                <b-icon icon="chevron-down" class="has-text-default"></b-icon>
              </div>
              <b-dropdown-item class="pdl-20px">
                <p class="has-text-icon-more is-size-7">
                  {{$t('detailBailleur.titleAccesRapide')}}
                </p>
              </b-dropdown-item>
              <b-dropdown-item class="is-paddingless"
                               v-for="(accesRapide, index) in genererAllAccesRapide" :key="index">
                <router-link-blank :to="{ name: accesRapide.name,
                                      params: accesRapide.params}"
                                   class="pdt-5px pdb-5px"
                                   classMessage="has-text-default is-size-6 is-block
                                     mgl-20px mgr-20px"
                                   classComposant="noTextDecoration"
                                   :message="accesRapide.libelle">
                </router-link-blank>
              </b-dropdown-item>
            </b-dropdown>
            <button class="button is-bottom-left has-text-left"
                    @click="checkPermissions(permsBailleur.lecture)
                      ? popUpEdition = true
                      : showPopUp()">
              <b-icon icon="file-download" type="is-default"></b-icon>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="permsBailleur.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab">
       <ul>
          <router-link :to="{ name: 'c.baux.bailleur' }"
                       :class="{'text-access-no-permission':
                          !checkPermissions(permsBailleur.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.baux.bailleur'
            }">
              {{ $t('detailBailleur.tab.bailleur') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'c.baux.bailleur-contrat' }"
                       :class="{'text-access-no-permission':
                          !checkPermissions(permsBailleur.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.baux.bailleur-contrat'
            }">
              {{ $t('detailBailleur.tab.baux') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'c.baux.bailleur-faces' }"
                       :class="{'text-access-no-permission':
                          !checkPermissions(permsBailleur.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.baux.bailleur-faces'
            }">
              {{ $t('detailBailleur.tab.faces') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'c.baux.bailleur-ecrans' }"
                       :class="{'text-access-no-permission':
                          !checkPermissions(permsBailleur.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.baux.bailleur-ecrans'
            }">
              {{ $t('detailBailleur.tab.ecranNumeriques') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'c.baux.bailleur-enCours' }"
                       :class="{'text-access-no-permission':
                          !checkPermissions(permsBailleur.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.baux.bailleur-enCours'
            }">
              {{ $t('detailBailleur.tab.encours') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'c.baux.bailleur-compte' }"
                       :class="{'text-access-no-permission':
                          !checkPermissions(permsBailleur.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.baux.bailleur-compte'
            }">
              {{ $t('detailBailleur.tab.compte') }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
    <router-view :bailleur="bailleur" :afficherColonneAction="false"
               :tiersId="this.tiersId"
               :tiersInformation="bailleur"
               :soldeAtInfiniteDay="soldeAtInfiniteDay"
               :soldeTiersInfo="soldeBailleurInfo"
               :isFromDetailClient="false"
               :afficherActionGroupe="false"
               :tiers="bailleur"
               v-if="bailleur"
    ></router-view>
    <b-modal v-model="popUpDelete"
            has-modal-card
            class="modal">
      <pop-up-prevention :mess-header="this.$t('listeBailleur.suppression.title')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         :is-error-popup="errorPopUp"
                         :messages-popup="messagesPopup"
                         @yes="deleteBailleur"
                         @no="popUpDelete = false">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-if="bailleur"
      v-model="openPopUpFusionTiers"
      :width="800"
      class="modal"
      has-modal-card>
      <popup-fusion-tiers
        :tiers="bailleur"
        :type="constantes.TIERS_TYPE_FOURNISSEUR"
        :sousTypes="bailleur.sousTypes"
        tiersTypeForTrad="bailleur">
      </popup-fusion-tiers>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="listeChoiceEdition"
        :filtreDates="true"
        @editionChoose="edition">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import dropdownButton from '@/components/general/button/dropdownButton';
import { get, deleteBailleur } from '@/api/tiers';
import { getAllByTiers } from '@/api/contacts';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { BAILLEUR } from '@/configuration/baux/permissionsBauxConf';
import genererCritereRechercheContrat from '@/services/baux/contrat/genererCritereRechercheContrat';
import { SET_CRITERE, SET_CONTRAT } from '@/store/modules/baux/contrat-mutation-type';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import validationSuppression from '@/services/baux/bailleur/validationSuppression';
import genererContrat from '@/services/baux/contrat/genererContrat';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import genererIntervenantContrat from '@/services/baux/contrat/genererIntervenantContrat';
import { INFINITE_DAY } from '@/configuration/general';
import { getSolde } from '@/api/mouvementClient/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { OPERATION_DIVERSE } from '@/configuration/compta/permissionsComptaConf';
import genererOperationDiverse from '@/services/compta/operationDiverse/genererOperationDiverse';
import { SET_OPERATION_DIVERSE } from '@/store/modules/compta/operationDiverse-mutation-type';
import popupFusionTiers from '@/components/clients/clients/popupFusionTiers';
import {
  LISTE_CHOICE_EDITION_TIERS,
  TIERS_TYPE_FOURNISSEUR,
  TYPE_DONNEE_EXTRAIT_COMPTE_TIERS,
} from '@/configuration/tiers/tiersConf';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition';
import validationGeneral from '@/services/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const Contrat = createNamespacedHelpers('contrat');
const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');
const OperationDiverse = createNamespacedHelpers('operationDiverse');

export default {
  data() {
    return {
      bailleur: null,
      permsBailleur: BAILLEUR,
      popUpDelete: false,
      messagesPopup: [],
      errorPopUp: false,
      contrat: null,
      tiersId: null,
      soldeAtInfiniteDay: 0,
      soldeBailleurInfo: 0,
      openPopUpFusionTiers: false,
      constantes: {
        TIERS_TYPE_FOURNISSEUR,
      },
      popUpEdition: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_TIERS
        .filter(l => l.typeDonnee === TYPE_DONNEE_EXTRAIT_COMPTE_TIERS),
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  components: {
    AppBreadcrumb,
    routerLinkBlank,
    dropdownButton,
    popUpPrevention,
    pieceJointeButton,
    popupFusionTiers,
    popUpEdition,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailBailleur.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailBailleur.breadcrumb.liste'), route: { name: 'l.baux.bailleur' }, isActive: false },
        { title: this.$i18n.t('detailBailleur.breadcrumb.detail'), route: { name: '' }, isActive: true },
      ];
    },
    genererAllAccesRapide() {
      return [
        { name: 'l.baux.contrat-by-tiers', params: { tiersId: this.tiersId }, libelle: this.$t('detailBailleur.actions.contrat') },
      ];
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('detailClient.actions.createOd'),
          action: () => { this.creerOd(); },
          permissionAction: OPERATION_DIVERSE.maj,
        },
        {
          label: this.$t('general.button.delete'),
          action: () => { this.popUpDelete = true; },
          permissionAction: BAILLEUR.supprimer,
        },
        {
          label: this.$t('detailClient.popupFusionTiers.bailleur.title'),
          action: () => { this.openPopUpFusionTiers = true; },
        },
      ];

      return actions;
    },

  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Contrat.mapMutations({
      setCritereRecherche: SET_CRITERE,
      setContrat: SET_CONTRAT,
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...OperationDiverse.mapMutations({
      setOperationDiverse: SET_OPERATION_DIVERSE,
    }),
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: [this.bailleur.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
          this.errorEdition.messages, this.errorEdition.messagesChampsVide);
        this.errorEdition.haveError = true;
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async deleteBailleur() {
      this.messagesPopup = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteBailleur([this.bailleur.id]);
        this.popUpDelete = false;
        messageSucces(this.$t('listeBailleur.suppression.sucess.bailleurDelete'));
        this.$router.push({ name: 'l.baux.bailleur' });
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.errorPopUp = true;
          validationSuppression(e.response, this.messagesPopup);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    genererContrat() {
      const intervenant = genererIntervenantContrat();
      intervenant.tiers = this.bailleur;
      intervenant.modeReglement = this.bailleur.modeReglement;
      intervenant.modeReglementId = this.bailleur.modeReglementId;
      intervenant.repartition = 100;
      intervenant.tiersId = this.$route.params.id;
      this.contrat.agenceId = this.agencesSelectionnees[0].agenceId;
      this.contrat.isComingFromBailleur = true;
      this.contrat.intervenants.unshift(intervenant);
      this.setContrat(this.contrat);
      this.$router.push({ name: 'm.baux.contrat-ajout' });
    },
    async getSoldeAtInfiniteDay() {
      const param = {
        tiersId: this.tiersId,
        date: formatIsoDate(INFINITE_DAY),
      };
      const responseSoldeBailleur = await getSolde(param);
      this.soldeAtInfiniteDay = responseSoldeBailleur.data.result;
    },
    async getSoldeBailleur() {
      const param = {
        tiersId: this.tiersId,
        date: formatIsoDate(new Date()),
      };
      const responseSoldeBailleur = await getSolde(param);
      this.soldeBailleurInfo = responseSoldeBailleur.data.result;
    },
    creerOd() {
      const od = genererOperationDiverse();
      od.mouvementOd.tiersId = this.tiersId;
      od.mouvementOd.tiers = this.bailleur;
      this.setOperationDiverse(od);
      this.$router.push({ name: 'm.comptabilite.operation_diverse-add' });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.setCritereRecherche(genererCritereRechercheContrat());
    next();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.tiersId = this.$route.params.id;
      await this.setAttachmentContext({ module: 'Client' });
      const bailleur = (await get(this.$route.params.id)).data.result;
      bailleur.contacts = (await getAllByTiers(bailleur.id)).data.result.items;
      await this.setAttachmentElementId({ id: bailleur.id });
      this.bailleur = bailleur;
      const contratNatureFind = this.parametre(PARAMETRES_KEYS.contratNature)
        .find((contratNature) => {
          return contratNature.valeurParDefaut;
        });
      this.contrat = genererContrat(contratNatureFind ? contratNatureFind.id : null);
      this.contrat.intervenants.push(genererIntervenantContrat());
      await this.getSoldeAtInfiniteDay();
      await this.getSoldeBailleur();
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.bailleur.nomCommercial }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
